import { userConstants } from '../_constants';
import { userService } from '../_services';

const initialState = { loggedIn: userService.loggedIn(), user: userService.userPool.getCurrentUser() }
if (initialState["user"]){
	initialState["user"].getSession((err, session) => {
		if (err) {
			console.log(err);
		}
		initialState["session"] = session;
	})
}

export function authentication(state = initialState, action) {
//	console.log('authentication reducer was called with state', state, 'and action', action)
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
			console.log(initialState)
      return {
				...state,
        loggingIn: true,
				loggedIn: false,
        user: action.username
      };
    case userConstants.LOGIN_SUCCESS:
      return {
				...state,
        loggedIn: true,
        loggingIn: false,
        session: action.session
      };
    case userConstants.LOGIN_FAILURE:
      return {
				loggedIn: false
			};
    case userConstants.LOGOUT:
      return {
				loggedIn: false
			};
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/authentication.js